import React from "react"
import { Card, CardBody } from "reactstrap"

import GradeGrid from "../../../Grade/components/GradeGrid"
import GradeHeader from "../../../Grade/components/GradeHeader"
import { getStartOfWeek } from "../../../../utils/date"

export default function ClassesGradeCard({
    turn,
    onTurnChange,
    view,
    onViewChange,
    referenceDate,
    onReferenceDateChange,
    schedules,
    onClassClick,
    selectedClassId,
    loading,
}) {
    return (
        <Card className="class-form-card mt-4 border-0 shadow-sm overflow-hidden animate-fade-in rounded-0">
            <CardBody className="p-4">
                <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-3 bg-white">
                    <h5 className="mb-0 fw-bold text-dark d-flex align-items-center">
                        <i className="mdi mdi-grid me-2 text-primary font-size-20"></i>
                        Horários Disponíveis (Grade)
                    </h5>
                    <div className="text-muted small">Visualização de turmas e ocupação</div>
                </div>

                <div className="mb-4">
                    <GradeHeader
                        turn={turn}
                        onTurnChange={onTurnChange}
                        view={view}
                        onViewChange={onViewChange}
                        referenceDate={referenceDate}
                        onReferenceDateChange={onReferenceDateChange}
                    />
                </div>

                <div className="rounded-0 overflow-hidden border">
                    <GradeGrid
                        turn={turn}
                        view={view}
                        referenceDate={referenceDate}
                        weekStart={getStartOfWeek(referenceDate)}
                        schedules={schedules}
                        onSelectSchedule={onClassClick}
                        selectedClassId={selectedClassId}
                        loading={loading}
                    />
                </div>
            </CardBody>
        </Card>
    )
}
